import { Controller } from '@hotwired/stimulus';

import { getCsrfToken } from '../csrf';

export default class extends Controller {
  static values = {
    redirect: String,
    dismissUrl: String,
    redirectTarget: String,
  };

  static targets = ['welcome', 'modal'];

  welcomeTarget: HTMLDivElement;

  modalTarget: HTMLDivElement;

  closeIcon: HTMLInputElement | null;

  connect(): void {
    this.closeIcon = this.modalTarget.querySelector('.sc-Modal-close');
    if (this.closeIcon) {
      this.closeIcon.addEventListener('click', () => {
        this.close();
      });
      this.modalTarget.classList.add('is-open');
    }
  }

  saveModelDismiss(): void {
    // @ts-expect-error TS2769 violates strict null checks
    void fetch(this.data.get('dismissUrl'), {
      headers: {
        'X-CSRF-Token': getCsrfToken(),
        'X-REQUESTED-WITH': 'XMLHttpRequest',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      method: 'post',
    });
  }

  closeAndRedirect() {
    // @ts-expect-error TS2531 violates strict null checks
    this.closeIcon.click();
    const redirectValue = this.data.get('redirectValue');

    if (redirectValue) {
      window.open(redirectValue, this.data.get('redirectTarget') || '_blank');
    }
  }

  close(): void {
    this.saveModelDismiss();
  }
}
